// extracted by mini-css-extract-plugin
export default {"accordionWrapper":"Rzzj_accordionWrapper__YnZ7P","headingTop":"Rzzj_headingTop__AykMa","overlayWrapper":"Rzzj_overlayWrapper__w+AGm"};